import React, { useState } from "react";
import {
  useToast,
  VStack,
  Button,
  FormErrorMessage,
  HStack,
  FormControl,
  FormLabel,
  Input,
  InputRightElement,
  InputGroup,
} from "@chakra-ui/react";
import LogoWordMark from "../Assets/LogoWordMark";
import { useAuth } from "../Contexts/AuthContext";

const Verify = () => {
  const { getToken, signOut } = useAuth();
  const [passwordInput, setPasswordInput] = useState();
  const [passwordError, setPasswordError] = useState();
  const [show, setShow] = useState();

  const handleSubmit = e => {
    e.preventDefault();
    if (!passwordInput || !passwordInput.length) {
      setPasswordError("This is required");
      return;
    } else setPasswordError(null);
    return getToken(passwordInput).catch(error => setPasswordError(error));
  };
  return (
    <VStack spacing={12}>
      <LogoWordMark w="120px" />
      <VStack spacing="20px" w="320px">
        <FormControl isRequired isInvalid={passwordError}>
          <FormLabel>Admin Password</FormLabel>
          <InputGroup>
            <Input
              type={show ? "text" : "password"}
              autoComplete="new-password"
              placeholder="Admin password"
              bg="#FAFAFB"
              borderRadius="8px"
              borderColor="#F1F1F5"
              onChange={e => setPasswordInput(e.target.value)}
            />
            <InputRightElement width="4.5rem">
              <Button h="1.75rem" size="sm" onClick={() => setShow(s => !s)}>
                {show ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
          <FormErrorMessage>{passwordError}</FormErrorMessage>
        </FormControl>
        <HStack>
          <Button
            w="full"
            px="25px"
            colorScheme="red"
            borderRadius="8px"
            onClick={e => {
              e.preventDefault();
              signOut();
            }}
          >
            Sign Out
          </Button>
          <Button
            w="full"
            px="20px"
            colorScheme="telegram"
            borderRadius="8px"
            onClick={e => handleSubmit(e)}
          >
            Continue
          </Button>
        </HStack>
      </VStack>
    </VStack>
  );
};

export default Verify;
